<template>
  <b-form-group :label-for="fieldId" class="legal-checkbox-wrapper">
    <b-card border-variant="light" class="mb-2">
      <div class="d-flex align-items-start">
        <b-form-checkbox
          :id="fieldId"
          :checked="value"
          :disabled="disabled"
          class="mr-3 mt-1"
          @input="handleChange"
        />

        <div class="flex-grow-1">
          <div class="legal-text">
            <strong>{{ title }}</strong>
            <p class="mb-1 mt-1">{{ description }}</p>
            <small v-if="legalReference" class="text-muted">
              <em>{{ legalReference }}</em>
            </small>
          </div>
        </div>
      </div>
    </b-card>
  </b-form-group>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue"

export default {
  name: 'LegalCheckbox',
  components: {
    BFormCheckbox,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    fieldId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    legalReference: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handleChange = value => {
      emit('input', value)
      emit('change', value)
    }

    return {
      handleChange,
    }
  },
}
</script>

<style scoped>
.legal-checkbox-wrapper {
  margin-bottom: 0.5rem;
}

.legal-text {
  font-size: 0.95rem;
}

.legal-text p {
  color: #6c757d;
  line-height: 1.5;
}

.legal-text strong {
  color: #2c3e50;
}
</style>
